import { render, staticRenderFns } from "./afterSaleDetails.vue?vue&type=template&id=578532f0&scoped=true&"
import script from "./afterSaleDetails.vue?vue&type=script&lang=js&"
export * from "./afterSaleDetails.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleDetails.vue?vue&type=style&index=0&id=578532f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578532f0",
  null
  
)

export default component.exports